/* eslint-disable max-len */
import React, { Fragment } from 'react';
import { bool, func } from 'prop-types';
import Moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  addDistToQueue,
  submitDistCampaign,
} from '../../../../actions/deActions/deDistributeActions';

const DistributeModalContent = ({ onClose, hasPermission }) => {
  const dispatch = useDispatch();
  const distRequest = useSelector(state => state.deDistribute.distRequest);
  
  const selectedtarget = useSelector(
    state => state.deDistribute.selectedTarget
  );
  const targetName = selectedtarget ? selectedtarget.name : '';
  const targetStudy = selectedtarget ? selectedtarget.study : '';
  const _handleSubmit = () => {
    dispatch(submitDistCampaign());
    setTimeout(() => {
      onClose();
    }, 100);
  };

  const _handleAddtoQueue = () => {
    dispatch(addDistToQueue());
    setTimeout(() => {
      onClose();
    }, 100);
  };


  const renderRightMessage = () => {
    if (!hasPermission) {
      return (
        <div>
          <div className="de__dest-modal__desc--title">Like what you see? </div>
          <div className="de__dest-modal__desc--copy">
            <p>
              To learn more about the Activate Campaign Targets solution please
              contact your account representative or email{' '}
              <a href="mailto:clientservices.ms@mrisimmons.com">
                clientservices.ms@mrisimmons.com
              </a>
            </p>
            <p>
              Don’t worry you can still save your work so you can pick-up where
              you left off. Just click Add to Queue below.
            </p>
          </div>
        </div>
      );
    }
    return (
      <Fragment>
        <div className="de__dest-modal__desc--title">What to expect next</div>
        <div className="de__dest-modal__desc--copy">
          <ul>
            <li>
              You will receive an email confirming the details of your request{' '}
            </li>
            <li>
            A member of our team will review your request and reach out shortly to discuss any additional information needed for approval as well as next steps.{' '}
            </li>
          </ul>
        </div>
      </Fragment>
    );
  };
  const renderSubmitButton = () => {
    if (!hasPermission) {
      return (
        <button
          type="button"
          onClick={_handleAddtoQueue}
          className="de--btn de--btn__secondary"
        >
          Add to Queue
        </button>
      );
    }
    return (
      <button
        type="button"
        onClick={_handleSubmit}
        className="de--btn de--btn__secondary"
      >
        Submit
      </button>
    );
  };

  return (
    <div className="de__dest-modal__body">
      <div className="de__dest-modal__row">
        <div className="de__dest-modal__col-left">
          <div className="de__dest-modal__header">
            <div title={distRequest.name} className="de__dest-modal__title">
              {distRequest.name}
            </div>
          </div>
          <div className="de__dest-modal__info">
            <div className="de__dest-modal__info--detail">
              <div className="de__dest-modal__info--title">Target</div>
              <div className="de__dest-modal__info--name">{targetName}</div>
              <div className="de__dest-modal__info--study">{targetStudy}</div>
            </div>
            <div className="de__dest-modal__info--detail">
              <div className="de__dest-modal__info--title">For Activation</div>
              <div className="de__dest-modal__info--name">
                {distRequest.isForActivation
                  ? `YES ${Moment(distRequest.startDate).format(
                      'MM/DD/YYYY'
                    )} - ${Moment(distRequest.endDate).format('MM/DD/YYYY')}`
                  : 'OFF'}
              </div>
            </div>
            <div className="de__dest-modal__info--detail noMargin">
              <div className="de__dest-modal__info--title">Destinations</div>
            </div>
          </div>
          <div className="de__dest-modal__destinations">
            <div className="distro__row distro__dest">
              <div className="distro__partners">
                <div className="distro__partners--selection">
                  <div className="distro__partners--selection--empty">
                    {Object.keys(distRequest.dest).length} Selections
                  </div>
                </div>
                <div className="distro__partners--list">
                  <div className="distro__partners--list--row">
                    {distRequest.dest.map(camp => {
                      return (
                        <div
                          className="distro__partners--list--col"
                          key={camp.id}
                        >
                          <div className="distro__partner--card">
                            <div className="distro__partner--card--button">
                              <div className="distro__partner--image">
                                <img src={camp.logo} alt={camp.name} />
                              </div>
                              <div className="distro__partner--title">
                                {camp.name}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!hasPermission && (
            <div className="de__dest-modal__col-left--overlay">
              <p>
                Whoops! We can’t complete the distribution because we did not
                find an active subscription.
              </p>
            </div>
          )}
        </div>
        <div className="de__dest-modal__col-right">
          <div className="de__dest-modal__desc">{renderRightMessage()}</div>
          <div className="de__dest-modal__footer">{renderSubmitButton()}</div>
        </div>
      </div>
    </div>
  );
};

DistributeModalContent.propTypes = {
  onClose: func,
  hasPermission: bool
};

export default DistributeModalContent;
